export abstract class Model {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  url: string;

  constructor(data?: any) {
    if (data) {
      this.id = data.id;
      this.createdAt = data.created_at;
      this.updatedAt = data.updated_at;
      this.url = data.url;
    }
  }

  abstract toJson(): any;
}



// WEBPACK FOOTER //
// ./src/app/models/model.ts